var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4979 11.9963L23.6535 9.88666C24.296 9.27836 23.9964 8.19733 23.1536 7.99577L20.2169 7.24624L21.0447 4.33929C21.2787 3.50313 20.4902 2.71446 19.6544 2.94846L16.7484 3.7766L15.9991 0.838896C15.8009 0.00925523 14.7077 -0.294167 14.1089 0.338833L12 2.51111L9.89114 0.33888C9.29911 -0.286948 8.20144 -0.000213593 8.00091 0.838943L7.25165 3.77665L4.34564 2.94851C3.50953 2.71441 2.72137 3.50336 2.95528 4.33933L3.78314 7.24629L0.84642 7.99582C0.00323278 8.19743 -0.295783 9.27865 0.346499 9.88666L2.50205 11.9963L0.346499 14.1058C-0.296064 14.7141 0.00356099 15.7952 0.846373 15.9967L3.78309 16.7463L2.95523 19.6532C2.72128 20.4894 3.50972 21.278 4.34559 21.044L7.25156 20.2159L8.00081 23.1536C8.20889 24.0243 9.29906 24.2794 9.89105 23.6537L12 21.4974L14.1089 23.6537C14.6948 24.2859 15.7957 24.0046 15.9991 23.1536L16.7483 20.2159L19.6543 21.044C20.4904 21.2781 21.2786 20.4892 21.0447 19.6532L20.2168 16.7463L23.1535 15.9967C23.9967 15.7951 24.2957 14.7139 23.6534 14.1058L21.4979 11.9963Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaCertificate);
export default __webpack_public_path__ + "static/media/FaCertificate.7d9a3ac7fe83042b71b653d1ae20285e.svg";
export { ForwardRef as ReactComponent };